import React from 'react';
import { Provider as StoreProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { setDefaultLang } from 'ttag';

import SplashScreen from 'components/SplashScreen';
import 'core-js/stable';
import SessionRecorder from 'lib/SessionRecorder';
import NotificationProvider from 'lib/notification/NotificationProvider';
import ScreenSizeProvider from 'lib/screenSize';
import { init } from 'lib/sentry';
import 'lib/yup/setupValidator';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import RootRouter from 'routes/RootRouter';
import { store } from 'store';

import { mountPage } from './utils';

import 'styles/common.css';

init();

const persistor = persistStore(store);

setDefaultLang('uk');

mountPage(
  <ScreenSizeProvider>
    <SessionRecorder>
      <StoreProvider store={store}>
        <PersistGate persistor={persistor} loading={<SplashScreen />}>
          <BrowserRouter>
            <RootRouter />
            <NotificationProvider />
          </BrowserRouter>
        </PersistGate>
      </StoreProvider>
    </SessionRecorder>
  </ScreenSizeProvider>,
);
